<template>
<SrcBackground>
  <HeadlineSub :title="$t('energymeter.headline')" :titleadd="' '+this.decodeHtml(this.$store.state.WbName)" target="/Main" :hassubline=true :hasmenu=false>
        <template #icon>
          <IconDataUsage class="w-12 h-12"/>
        </template>
        <template #subline>
          <span v-html="$t('energymeter.energyloadedtotal', { Energy: $n( energytotal, 'decimal' ) } )"></span>
        </template>
  </HeadlineSub>

    <div class="px-4 my-6 max-w-5xl">

    <div class="md:flex md:items-start">
      <div v-if="powertotal>0" class="w-full md:w-auto md:mr-4 text-center md:inline-flex mb-6">
          <vc-donut class=""
            background=rgb(var(--color-b-back)) foreground=rgb(var(--color-active-hsl-224))
            :size="240" unit="px" :thickness="26"
            :sections="sections" :total="donutmaxpower"
            :start-angle="0" :auto-adjust-text-size="true">
              <svg class="m-auto" width="200" height="200" viewbox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                <circle cx="100" cy="100" fill="none" r="50" stroke=rgb(var(--color-active-hsl-192)) stroke-width="8">
                  <animate attributeName="r" from="42" to="100" dur="1.5s" begin="0s" repeatCount="indefinite"/>
                  <animate attributeName="opacity" from="1" to="0" dur="1.5s" begin="0s" repeatCount="indefinite"/>
                </circle>
                <circle cx="100" cy="100" fill=rgb(var(--color-active-hsl-128)) r="50"/>
                <text class="font-bold text-2xl" x="50%" y="47%" dominant-baseline="middle" text-anchor="middle" fill=rgb(var(--color-text-inverted))>{{ $n( powertotal, 'decimal' ) }}</text>
                <text class="font-bold text-xl" x="50%" y="62%" dominant-baseline="middle" text-anchor="middle" fill=rgb(var(--color-text-inverted))>kW</text>
              </svg>
          </vc-donut>
      </div> 

      <div class="md:inline-block w-full mb-6">
      <table class="md:grow w-full bg-skin-b-list-back border border-skin-b-list-bord shadow rounded-xl">
            <thead class="bg-skin-b-list-head text-skin-b-list-base text-center">
                <tr>
                    <th scope="col" class="py-4 px-1">
                      {{ $t('energymeter.phase') }}
                    </th>
                    <th scope="col" class="py-4 px-3">
                      {{ $t('energymeter.voltage') }}
                    </th>
                    <th scope="col" class="py-4 px-3">
                      {{ $t('energymeter.current') }}
                    </th>
                    <th scope="col" class="py-4 px-3">
                      {{ $t('energymeter.power') }}
                    </th>
                    <th scope="col" class="py-4 px-1">
                      {{ $t('energymeter.loadpoint') }}
                    </th>
                </tr>
            </thead>
            <tbody class="">
                <tr v-for="index in 3" :key="index" 
                    class="font-semibold text-lg border-t border-skin-b-list-bord text-skin-b-list-base text-center">
                    <th scope="row" class="py-4 px-1 whitespace-nowrap">
                     L{{ index.toString() }}
                    </th>
                    <td class="py-4 px-3">
                      {{ $t('energymeter.voltagevalue', { count: $n( this.midtable[`voltageL${index.toString()}`], 'decimal1' ) } ) }}
                    </td>                    
                    <td class="py-4 px-3">
                      {{ $t('energymeter.currentvalue', { count: $n( this.midtable[`currentL${index.toString()}`], 'decimal1' ) } ) }}
                    </td>
                    <td class="py-4 px-3">
                      {{ $t('energymeter.powervalue', { count: $n( this.midtable[`powerL${index.toString()}`], 'decimal' ) } ) }}
                    </td>
                    <td class="py-4 px-1">
                       &rarr;&nbsp;L{{ wired[`l${index}wiredto`] }}
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
      </div>

        <div class="grid gap-4 md:grid-cols-2">
            <div class="w-full bg-skin-b-list-head border border-skin-b-list-bord shadow rounded-lg inline-flex items-center">
              <svg class="ml-6" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
                <path d="M363 866q-16 0-29-9t-18-23l-97-228H48v-60h213l102 241 187-467q5-14 18-23t29-9q16 0 29 9t18 23l97 226h171v60H699L597 367 410 834q-5 14-18 23t-29 9Z"/>
              </svg>
              <h4 class="p-6 text-skin-b-list-base font-semibold text-lg md:text-xl leading-tight truncate">
                <span v-html="$t('energymeter.frequency', { count: $n( frequency, 'decimal' ) } )"></span>
              </h4> 
            </div>
            <div v-if="powertotal>0" class="w-full bg-skin-b-list-head border border-skin-b-list-bord shadow rounded-lg inline-flex items-center">
              <svg class="ml-6" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
                <path d="m462 874 170-360H502V274L332 634h130v240Zm18 102q-85 0-158-30.5T195 861q-54-54-84.5-127T80 576q0-84 30.5-157T195 292q54-54 127-85t158-31q84 0 157 31t127 85q54 54 85 127t31 157q0 85-31 158t-85 127q-54 54-127 84.5T480 976Zm0-400Zm0 340q145 0 242.5-97.5T820 576q0-145-97.5-242.5T480 236q-145 0-242.5 97.5T140 576q0 145 97.5 242.5T480 916Z"/>
              </svg>
              <div>
                <h4 class="px-6 pt-6 text-skin-b-list-base font-semibold text-lg md:text-xl">
                  <span v-html="$t('energymeter.actualpower', { count: $n( powertotal, 'decimal' ) } )"></span>
                </h4>
                <h4 v-if="donutmaxpower!=donutmaxpowerinstall" class="px-6 pt-2 -mb-2 text-skin-b-list-mute font-semibold text-sm md:text-lg">
                  <span v-html="$t('energymeter.maxpoweroperator', { count: $n( donutmaxpower/1000, 'decimal' ) } )"></span>
                </h4> 
                <h4 class="px-6 pt-2 pb-6 text-skin-b-list-mute font-semibold text-sm md:text-lg">
                  <span v-html="$t('energymeter.maxpowerinstall', { count: $n( donutmaxpowerinstall/1000, 'decimal' ) } )"></span>
                </h4> 
              </div>
            </div>         
        </div>
        <div v-if="lastUpdate!=''" class="mt-2">
          {{ $t('energymeter.refreshdate', {date: lastUpdate} )  }}
        </div>
    </div>

</SrcBackground>
</template>

<script>
import IconDataUsage from './icons/IconDataUsage.vue'
import SrcBackground from './sources/SrcBackground.vue'
import HeadlineSub from './elements/HeadlineSub.vue'
import { useI18n } from 'vue-i18n'

export default {
  name: 'StatusPage',
  components: {
    IconDataUsage,
    SrcBackground,
    HeadlineSub
  },
  setup () {
    // You can use t/d/n directly in template if you want: {{ t('key') }}
    const { t, d, n } = useI18n()
    return { t, d, n }
  },
  data () {
    return {
      polling: true,
      midUrl: '',
      settingsUrl: '',

      energytotal: 0,
      donutmaxpowerinstall: 22080, // W
      donutmaxpower: 22080,        // W
      donutpowertotal: 0,          // W
      powertotal: 0,               // kW
      frequency: 0,
      lastUpdate: '',

      // treat this as an object, not an array
      midtable: {
        lastUpdate: null,
        energyTotal: 0,
        voltageL1: 0,
        voltageL2: 0,
        voltageL3: 0,
        currentL1: 0,
        currentL2: 0,
        currentL3: 0,
        powerL1: 0,
        powerL2: 0,
        powerL3: 0,
        frequency: 0
      },

      wired: {
        l1wiredto: 0,
        l2wiredto: 0,
        l3wiredto: 0
      },

      client_setting: [],

      sections: [
        { label: 'Ladestrom', value: 0, color: 'rgb(var(--color-active-hsl-128))' }
      ]
    }
  },
  methods: {
    decodeHtml (html) {
      const txt = document.createElement('textarea')
      txt.innerHTML = html
      return txt.value
    },

    /**
     * Convert raw mid-meter data from backend into
     * display-ready values and update component state.
     */
    applyMidtableData (rawMidtable) {
      this.midtable = { ...rawMidtable }

      // Last update timezone adjustment
      if (this.midtable.lastUpdate) {
        const tzOffset = new Date(this.midtable.lastUpdate).getTimezoneOffset()
        this.lastUpdate = this.$dayjs(
          this.$dayjs(this.midtable.lastUpdate).subtract(tzOffset, 'minute')
        ).format('DD.MM.YYYY HH:mm')
      }

      // Convert units
      this.energytotal = this.midtable.energyTotal / 1000 // Wh -> kWh

      this.midtable.voltageL1 = this.midtable.voltageL1 / 1000 // mV -> V
      this.midtable.voltageL2 = this.midtable.voltageL2 / 1000
      this.midtable.voltageL3 = this.midtable.voltageL3 / 1000

      this.midtable.currentL1 = this.midtable.currentL1 / 1000 // mA -> A
      this.midtable.currentL2 = this.midtable.currentL2 / 1000
      this.midtable.currentL3 = this.midtable.currentL3 / 1000

      this.midtable.powerL1 = this.midtable.powerL1 / 1_000_000 // µW -> kW
      this.midtable.powerL2 = this.midtable.powerL2 / 1_000_000
      this.midtable.powerL3 = this.midtable.powerL3 / 1_000_000

      this.frequency = this.midtable.frequency / 1000 // mHz -> Hz

      // Totals
      this.powertotal =
        parseFloat(this.midtable.powerL1 || 0) +
        parseFloat(this.midtable.powerL2 || 0) +
        parseFloat(this.midtable.powerL3 || 0)

      this.donutpowertotal = this.powertotal * 1000 // kW -> W for donut
      this.sections[0].value = this.donutpowertotal
    },

    pollData () {
      if (!this.polling) return

      console.log('get Polldata status')
      this.axios
        .get(this.midUrl)
        .then((response) => {
          if (response.data.status === 'ok') {
            this.applyMidtableData(response.data.tbl_mid_meter)

            if (response.data.status !== '') {
              setTimeout(() => {
                this.execpoll(this.polling)
              }, 1000)
            }
          } else {
            console.log('fehler get midmeter')
          }
        })
        .catch((errors) => {
          console.log(errors)
          this.execpoll(this.polling)
        })
    },

    execpoll (polling) {
      if (polling) {
        this.pollData()
      }
    }
  },
  created () {
    const state = this.$store.state

    if (state.Mesh) {
      this.midUrl =
        'wallbox/info.php?action=get_mid_status&user=' +
        state.token +
        '&client=' +
        state.WbId
      this.settingsUrl =
        'wallbox/info.php?action=get_settings&user=' +
        state.token +
        '&client=' +
        state.WbId
    } else {
      this.midUrl =
        'wallbox/info.php?action=get_mid_status&user=' + state.token
      this.settingsUrl =
        'wallbox/info.php?action=get_settings&user=' + state.token
    }

    const requestclient_setting = this.axios.get(this.settingsUrl)
    const requestclient_mid = this.axios.get(this.midUrl)

    this.axios
      .all([requestclient_setting, requestclient_mid])
      .then(
        this.axios.spread((responseclient_setting, responseclient_mid) => {
          // SETTINGS
          if (responseclient_setting.data.status === 'token') {
            this.$router.push({ path: '/' })
          } else if (responseclient_setting.data.status === 'ok') {
            this.client_setting = responseclient_setting.data.tbl_settings

            this.donutmaxpowerinstall =
              this.client_setting.maxCurrentInstall *
              this.client_setting.noOfPhasesInstall *
              230

            this.donutmaxpower =
              this.client_setting.maxCurrentOperator *
              this.client_setting.noOfPhasesInstall *
              230

            this.wired.l1wiredto = this.client_setting.l1WiredTo
            this.wired.l2wiredto = this.client_setting.l2WiredTo
            this.wired.l3wiredto = this.client_setting.l3WiredTo
          } else {
            console.log('Error get client_setting')
          }

          // MID DATA
          if (responseclient_mid.data.status === 'token') {
            this.$router.push({ path: '/' })
          } else if (responseclient_mid.data.status === 'ok') {
            this.applyMidtableData(responseclient_mid.data.tbl_mid_meter)
            this.pollData()
          } else {
            console.log('Error get client_mid')
          }
        })
      )
      .catch((errors) => {
        console.error(errors)
      })
  },
  beforeUnmount () {
    this.polling = false
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* top-left border-radius */
table tr:first-child th:first-child {
  border-top-left-radius: 0.75rem;
}

/* top-right border-radius */
table tr:first-child th:last-child {
  border-top-right-radius: 0.75rem;
}
</style>
